import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteGoalsGoalDetailsFuncEval } from './DetailsFuncEval';
import { PatientCareCenterNoteGoalsGoalDetailsFuncDN } from './DetailsFuncDN';
import { PatientCareCenterNoteGoalsGoalDetailsFuncDelete } from './DetailsFuncDelete';
import { PatientCareCenterNoteGoalsGoalDetailsFuncPN } from './DetailsFuncPN';
import { PatientCareCenterNoteGoalsGoalDetailsFuncDC } from './DetailsFuncDC';
import { PatientCareCenterNoteGoalsGoalDetailsFuncFreeForm } from './DetailsFuncFreeForm';
import { PatientCareCenterNoteGoalsGoalDetailsFuncEvalCustom } from './DetailsFuncEvalCustom';
import { PatientCareCenterNoteGoalsGoalDetailsFuncDNCustom } from './DetailsFuncDNCustom';
import { PatientCareCenterNoteGoalsGoalDetailsFuncPNCustom } from './DetailsFuncPNCustom';
import { PatientCareCenterNoteGoalsGoalDetailsFuncDCCustom } from './DetailsFuncDCCustom';

class PatientCareCenterNoteGoalsGoalDetailsFunc extends React.Component {

    render() {
        if (this.props.isFreeForm && !this.props.goal.GODELETED) {
            return (<PatientCareCenterNoteGoalsGoalDetailsFuncFreeForm id={this.props.id} days={this.props.days} />);
        } else if (this.props.noteType === 1 && !this.props.isCustom) { // eval
            return (<PatientCareCenterNoteGoalsGoalDetailsFuncEval id={this.props.id} days={this.props.days} />);
        } else if (this.props.noteType === 1 && this.props.isCustom) { // eval
            return (<PatientCareCenterNoteGoalsGoalDetailsFuncEvalCustom id={this.props.id} days={this.props.days} />);
        } else if (this.props.noteType === 2 && !this.props.isCustom) { // DN
            return (<PatientCareCenterNoteGoalsGoalDetailsFuncDN id={this.props.id} days={this.props.days} />);
        } else if (this.props.noteType === 2 && this.props.isCustom) { // DN
            return (<PatientCareCenterNoteGoalsGoalDetailsFuncDNCustom id={this.props.id} days={this.props.days} />);
        } else if ((this.props.noteType === 3 || this.props.noteType === 5) && this.props.goal.GODELETED) { // PN with deleted set
            return (<PatientCareCenterNoteGoalsGoalDetailsFuncDelete id={this.props.id} days={this.props.days} />);
        } else if ((this.props.noteType === 3 || this.props.noteType === 5) && !this.props.isCustom) { // PN
            return (<PatientCareCenterNoteGoalsGoalDetailsFuncPN id={this.props.id} days={this.props.days} />);
        } else if ((this.props.noteType === 3 || this.props.noteType === 5) && this.props.isCustom) { // PN
            return (<PatientCareCenterNoteGoalsGoalDetailsFuncPNCustom id={this.props.id} days={this.props.days} />);
        } else if ((this.props.noteType === 4 || this.props.noteType === 6) && !this.props.isCustom) {
            return (<PatientCareCenterNoteGoalsGoalDetailsFuncDC id={this.props.id} days={this.props.days} />);
        } else if ((this.props.noteType === 4 || this.props.noteType === 6) && this.props.isCustom) {
            return (<PatientCareCenterNoteGoalsGoalDetailsFuncDCCustom id={this.props.id} days={this.props.days} />);
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let isFreeForm = goal.GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_FREE_FORM_GOAL_ID'].PRVALUE) ? true : false;
    let isCustom = goal.GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE) ? true : false;
    let days = ownprops.days;
    return {
        noteId,
        noteType,
        pk,
        goal,
        isFreeForm,
        isCustom,
        days
    };
}

const connectedPatientCareCenterNoteGoalsGoalDetailsFunc = connect(mapStateToProps)(PatientCareCenterNoteGoalsGoalDetailsFunc);
export { connectedPatientCareCenterNoteGoalsGoalDetailsFunc as PatientCareCenterNoteGoalsGoalDetailsFunc };

